import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LineAsset, UserAsset } from '@models/dashboard.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ModalService } from '@services/modal/modal.service';

@Component({
  selector: 'ts-confirm-line-termination',
  templateUrl: './confirm-line-termination.component.html',
  imports: [TranslationPipe]
})
export class ConfirmLineTerminationComponent {
  @Input() modal_header: string;
  @Input() asset: LineAsset;
  @Output() confirmChangeCarrier: EventEmitter<boolean> = new EventEmitter();

  constructor(private modal_service: ModalService) {}

  continue(): void {
    this.confirmChangeCarrier.emit(true);
  }

  dismissModal(): void {
    this.modal_service.dismissLastModal('Close click');
  }
}
